module.exports = __webpack_public_path__ + "static/img/index_banner.76f4712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_banner.png
// module id = xD8V
// module chunks = 1